/* eslint-disable @oaknorth/ui/no-inline-styles -- inline styles ok for svg */
export function ONCILogoRingAndTextColour() {
  return (
    <svg width="100%" height="100%" viewBox="0 0 238 110" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_2073_2"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="100%"
        height="100%"
      >
        <mask
          id="mask1_2073_2"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="1"
          y="1"
          width="100%"
          height="100%"
        >
          <mask
            id="mask2_2073_2"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="1"
            y="1"
            width="100%"
            height="100%"
          >
            <path
              d="M54.8516 1C84.5729 1.00007 108.667 25.0941 108.667 54.8154C108.667 84.5367 84.5728 108.631 54.8516 108.631C25.1302 108.631 1.0362 84.5367 1.03613 54.8154C1.03613 25.0941 25.1302 1 54.8516 1ZM54.5361 22C36.5869 22 22.0361 36.7746 22.0361 55C22.0361 73.2254 36.5869 88 54.5361 88C72.4854 88 87.0361 73.2254 87.0361 55C87.0361 36.7746 72.4854 22 54.5361 22Z"
              fill="#D9D9D9"
            />
          </mask>
          <g mask="url(#mask2_2073_2)">
            <path
              d="M-35.6893 41.6208L41.3525 -37.5122L43.5743 -35.2904L-35.5586 41.7515L-35.6893 41.6208Z"
              fill="black"
            />
            <path d="M17.6346 94.9445L94.6764 15.8115L96.8982 18.0334L17.7653 95.0752L17.6346 94.9445Z" fill="black" />
            <path
              d="M-33.4674 43.8429L43.5744 -35.29L45.7963 -33.0682L-33.3367 43.9736L-33.4674 43.8429Z"
              fill="black"
            />
            <path d="M19.8564 97.1667L96.8982 18.0337L99.12 20.2555L19.9871 97.2974L19.8564 97.1667Z" fill="black" />
            <path
              d="M-31.2455 46.0646L45.7964 -33.0683L48.0182 -30.8465L-31.1148 46.1953L-31.2455 46.0646Z"
              fill="black"
            />
            <path d="M22.0782 99.3883L99.12 20.2554L101.342 22.4772L22.2089 99.519L22.0782 99.3883Z" fill="black" />
            <path
              d="M-29.0238 48.2863L48.018 -30.8467L50.2399 -28.6248L-28.8931 48.417L-29.0238 48.2863Z"
              fill="black"
            />
            <path d="M24.3001 101.61L101.342 22.4771L103.564 24.6989L24.4308 101.741L24.3001 101.61Z" fill="black" />
            <path d="M-26.802 50.508L50.2399 -28.625L52.4617 -26.4032L-26.6713 50.6387L-26.802 50.508Z" fill="black" />
            <path d="M26.522 103.832L103.564 24.6987L105.786 26.9206L26.6527 103.962L26.522 103.832Z" fill="black" />
            <path
              d="M-24.5802 52.7296L52.4617 -26.4033L54.6835 -24.1815L-24.4495 52.8603L-24.5802 52.7296Z"
              fill="black"
            />
            <path d="M28.7437 106.054L105.786 26.9209L108.007 29.1427L28.8744 106.185L28.7437 106.054Z" fill="black" />
            <path
              d="M-22.3582 54.9518L54.6836 -24.1811L56.9054 -21.9593L-22.2275 55.0825L-22.3582 54.9518Z"
              fill="black"
            />
            <path d="M30.9656 108.276L108.007 29.1426L110.229 31.3644L31.0963 108.406L30.9656 108.276Z" fill="black" />
            <path
              d="M-20.1366 57.1735L56.9053 -21.9595L59.1271 -19.7376L-20.0059 57.3042L-20.1366 57.1735Z"
              fill="black"
            />
            <path d="M33.1873 110.497L110.229 31.3643L112.451 33.5861L33.318 110.628L33.1873 110.497Z" fill="black" />
            <path
              d="M-17.9146 59.3952L59.1272 -19.7378L61.349 -17.5159L-17.7839 59.5259L-17.9146 59.3952Z"
              fill="black"
            />
            <path d="M35.4092 112.719L112.451 33.586L114.673 35.8078L35.5399 112.85L35.4092 112.719Z" fill="black" />
            <path
              d="M-15.6927 61.6173L61.3491 -17.5156L63.5709 -15.2938L-15.562 61.748L-15.6927 61.6173Z"
              fill="black"
            />
            <path d="M37.6311 114.941L114.673 35.8081L116.895 38.0299L37.7618 115.072L37.6311 114.941Z" fill="black" />
            <path d="M-13.471 63.839L63.5708 -15.2939L65.7926 -13.0721L-13.3403 63.9697L-13.471 63.839Z" fill="black" />
            <path d="M39.8528 117.163L116.895 38.0298L119.116 40.2516L39.9835 117.293L39.8528 117.163Z" fill="black" />
            <path
              d="M-11.2491 66.0607L65.7927 -13.0722L68.0145 -10.8504L-11.1184 66.1914L-11.2491 66.0607Z"
              fill="black"
            />
            <path d="M42.0747 119.384L119.117 40.2515L121.338 42.4733L42.2054 119.515L42.0747 119.384Z" fill="black" />
            <path
              d="M-9.02743 68.2829L68.0144 -10.8501L70.2362 -8.62825L-8.89674 68.4136L-9.02743 68.2829Z"
              fill="black"
            />
            <path d="M44.2964 121.607L121.338 42.4737L123.56 44.6955L44.4271 121.737L44.2964 121.607Z" fill="black" />
            <path
              d="M-6.80551 70.5045L70.2363 -8.6284L72.4581 -6.40657L-6.67481 70.6352L-6.80551 70.5045Z"
              fill="black"
            />
            <path d="M46.5183 123.828L123.56 44.6953L125.782 46.9172L46.649 123.959L46.5183 123.828Z" fill="black" />
            <path
              d="M-4.58358 72.7267L72.4582 -6.40623L74.6801 -4.18441L-4.45289 72.8574L-4.58358 72.7267Z"
              fill="black"
            />
            <path d="M48.7403 126.05L125.782 46.917L128.004 49.1388L48.871 126.181L48.7403 126.05Z" fill="black" />
            <path
              d="M-2.36178 74.9484L74.68 -4.18455L76.9019 -1.96273L-2.23109 75.0791L-2.36178 74.9484Z"
              fill="black"
            />
            <path d="M50.9619 128.272L128.004 49.1387L130.226 51.3605L51.0926 128.402L50.9619 128.272Z" fill="black" />
            <path
              d="M-0.139981 77.1701L76.9018 -1.96287L79.1237 0.258954L-0.00928567 77.3008L-0.139981 77.1701Z"
              fill="black"
            />
            <path d="M53.1839 130.494L130.226 51.3609L132.448 53.5827L53.3146 130.625L53.1839 130.494Z" fill="black" />
            <path d="M2.08194 79.3918L79.1238 0.258807L81.3456 2.48063L2.21264 79.5225L2.08194 79.3918Z" fill="black" />
            <path d="M55.4057 132.715L132.447 53.5825L134.669 55.8044L55.5364 132.846L55.4057 132.715Z" fill="black" />
            <path d="M4.30362 81.6134L81.3454 2.48049L83.5673 4.70231L4.43432 81.7441L4.30362 81.6134Z" fill="black" />
            <path d="M57.6275 134.937L134.669 55.8042L136.891 58.026L57.7582 135.068L57.6275 134.937Z" fill="black" />
            <path d="M6.52555 83.8356L83.5674 4.70265L85.7892 6.92448L6.65624 83.9663L6.52555 83.8356Z" fill="black" />
            <path d="M59.8494 137.159L136.891 58.0259L139.113 60.2477L59.9801 137.29L59.8494 137.159Z" fill="black" />
            <path d="M8.74723 86.0573L85.789 6.92433L88.0109 9.14616L8.87792 86.188L8.74723 86.0573Z" fill="black" />
            <path d="M62.0711 139.381L139.113 60.2481L141.335 62.4699L62.2018 139.512L62.0711 139.381Z" fill="black" />
            <path d="M10.9691 88.279L88.011 9.14601L90.2328 11.3678L11.0998 88.4097L10.9691 88.279Z" fill="black" />
            <path d="M64.293 141.603L141.335 62.4697L143.557 64.6916L64.4237 141.733L64.293 141.603Z" fill="black" />
            <path d="M13.191 90.5011L90.2328 11.3682L92.4546 13.59L13.3216 90.6318L13.191 90.5011Z" fill="black" />
            <path d="M66.5148 143.824L143.557 64.6914L145.778 66.9133L66.6455 143.955L66.5148 143.824Z" fill="black" />
            <path d="M15.4128 92.7228L92.4546 13.5899L94.6764 15.8117L15.5434 92.8535L15.4128 92.7228Z" fill="black" />
            <path d="M68.7367 146.047L145.779 66.9136L148 69.1354L68.8674 146.177L68.7367 146.047Z" fill="black" />
          </g>
        </mask>
        <g mask="url(#mask1_2073_2)">
          <rect x="-0.0180664" width="110" height="110" fill="url(#paint0_linear_2073_2)" />
        </g>
      </mask>
      <g mask="url(#mask0_2073_2)">
        <rect
          x="118"
          y="1"
          width="100%"
          height="100%"
          transform="rotate(90 114.9 -3.09814)"
          fill="url(#paint1_linear_2073_2)"
        />
      </g>
      <path d="M226.17 71.9928V38.0088H234.426V71.9928H226.17Z" fill="#191C20" />
      <path
        d="M224.065 67.2887C222.561 69.0167 220.705 70.3927 218.497 71.4167C216.289 72.4087 213.745 72.9047 210.865 72.9047C208.241 72.9047 205.809 72.4727 203.569 71.6087C201.361 70.7447 199.441 69.5287 197.809 67.9607C196.177 66.3607 194.897 64.4567 193.969 62.2487C193.041 60.0407 192.577 57.6087 192.577 54.9527C192.577 52.2327 193.041 49.7687 193.969 47.5607C194.929 45.3527 196.241 43.4807 197.905 41.9447C199.569 40.3767 201.521 39.1767 203.761 38.3447C206.001 37.5127 208.417 37.0967 211.009 37.0967C213.409 37.0967 215.761 37.5287 218.065 38.3927C220.401 39.2247 222.289 40.4567 223.729 42.0887L218.161 47.6567C217.393 46.6007 216.385 45.8167 215.137 45.3047C213.889 44.7927 212.609 44.5367 211.297 44.5367C209.857 44.5367 208.529 44.8087 207.313 45.3527C206.129 45.8647 205.105 46.5847 204.241 47.5127C203.377 48.4407 202.705 49.5447 202.225 50.8247C201.745 52.0727 201.505 53.4487 201.505 54.9527C201.505 56.4887 201.745 57.8967 202.225 59.1767C202.705 60.4567 203.361 61.5607 204.193 62.4887C205.057 63.3847 206.081 64.0887 207.265 64.6007C208.449 65.1127 209.745 65.3687 211.153 65.3687C212.785 65.3687 214.209 65.0487 215.425 64.4087C216.641 63.7687 217.617 62.9367 218.353 61.9127L224.065 67.2887Z"
        fill="#191C20"
      />
      <path
        d="M180.759 71.9928L167.079 49.7688H166.935L167.127 71.9928H159.159V38.0088H168.519L182.151 60.1848H182.295L182.103 38.0088H190.071V71.9928H180.759Z"
        fill="#191C20"
      />
      <path
        d="M156.675 54.8567C156.675 57.5447 156.211 60.0087 155.283 62.2487C154.355 64.4567 153.059 66.3607 151.395 67.9607C149.763 69.5287 147.811 70.7447 145.539 71.6087C143.267 72.4727 140.803 72.9047 138.147 72.9047C135.491 72.9047 133.027 72.4727 130.755 71.6087C128.515 70.7447 126.563 69.5287 124.899 67.9607C123.267 66.3607 121.987 64.4567 121.059 62.2487C120.131 60.0087 119.667 57.5447 119.667 54.8567C119.667 52.1367 120.131 49.6887 121.059 47.5127C121.987 45.3047 123.267 43.4327 124.899 41.8967C126.563 40.3607 128.515 39.1767 130.755 38.3447C133.027 37.5127 135.491 37.0967 138.147 37.0967C140.803 37.0967 143.267 37.5127 145.539 38.3447C147.811 39.1767 149.763 40.3607 151.395 41.8967C153.059 43.4327 154.355 45.3047 155.283 47.5127C156.211 49.6887 156.675 52.1367 156.675 54.8567ZM147.891 54.8567C147.891 53.3847 147.651 52.0087 147.171 50.7287C146.691 49.4487 146.019 48.3607 145.155 47.4647C144.323 46.5367 143.299 45.8167 142.083 45.3047C140.899 44.7607 139.587 44.4887 138.147 44.4887C136.707 44.4887 135.395 44.7607 134.211 45.3047C133.027 45.8167 132.003 46.5367 131.139 47.4647C130.275 48.3607 129.603 49.4487 129.123 50.7287C128.675 52.0087 128.451 53.3847 128.451 54.8567C128.451 56.3927 128.691 57.8167 129.171 59.1287C129.651 60.4087 130.307 61.5127 131.139 62.4407C132.003 63.3687 133.027 64.1047 134.211 64.6487C135.395 65.1607 136.707 65.4167 138.147 65.4167C139.587 65.4167 140.899 65.1607 142.083 64.6487C143.267 64.1047 144.291 63.3687 145.155 62.4407C146.019 61.5127 146.691 60.4087 147.171 59.1287C147.651 57.8167 147.891 56.3927 147.891 54.8567Z"
        fill="#191C20"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2073_2"
          x1="82.9819"
          y1="25.5"
          x2="5.48193"
          y2="105.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopOpacity="0.35" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2073_2"
          x1="122.892"
          y1="80.0084"
          x2="240.676"
          y2="27.4932"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42B2E5" />
          <stop offset="1" stopColor="#C747B6" />
        </linearGradient>
      </defs>
    </svg>
  );
}

//style={{ maskType: 'alpha' }}
